import { NotificationsWrap } from "./NotificationsWrap";

export class WebPushServiceWorker {
    private static serviceWorkerInstance: ServiceWorkerRegistration;

    static async register(): Promise<boolean> {
        try {
            const serviceWorkerUrl = NotificationsWrap.getServiceWorkerUrl();
            const existsServiceWorkerRegistrations = await WebPushServiceWorker.getSwRegistrations();
            if (existsServiceWorkerRegistrations) {
                this.serviceWorkerInstance = existsServiceWorkerRegistrations;
                console.log('Got exist service worker');
                return true;
            } else if (!existsServiceWorkerRegistrations) {
                this.serviceWorkerInstance = await navigator.serviceWorker.register(serviceWorkerUrl);
                console.log('New service worker was success installed');
                return true;
            } else {
                console.log('Service worker was exist', existsServiceWorkerRegistrations);
                return true;
            }
        } catch (exception) {
            console.error('ServiceWorker registration fault', exception);
            window.Sentry.captureException('ServiceWorker registration fault');
            return false;
        }
    }

    static async getInstance(): Promise<ServiceWorkerRegistration> {
        if (!this.serviceWorkerInstance) {
            await this.register();
        }
        return this.serviceWorkerInstance;
    }

    static async getSwRegistrations(): Promise<ServiceWorkerRegistration> {
        const swRegistrations: Array<ServiceWorkerRegistration> = await navigator.serviceWorker
            .getRegistrations() as Array<ServiceWorkerRegistration>;
        return (swRegistrations[0]) ? swRegistrations[0] : undefined;
    }

    public static async remove(): Promise<boolean> {
        const registration = await this.getSwRegistrations();
        if (registration) {
            return registration.unregister();
        }

        return true;
    }

    static async checkSwUpdates(registration: ServiceWorkerRegistration = null) {
        try {
            let swInstance = registration;
            if (swInstance === null) {
                swInstance = await WebPushServiceWorker.getInstance();
            }

            console.log('[Braze] try to update serviceworker');
            await swInstance.update();
            swInstance.onupdatefound = () => {
                console.log('[Braze] service worker has updated');
            };
        } catch (error) {
            window.Sentry.captureException(error);
        }
    }
}
